import { render, staticRenderFns } from "./ReceivableDetailsModal.vue?vue&type=template&id=7455a60b&scoped=true&"
import script from "./ReceivableDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ReceivableDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReceivableDetailsModal.vue?vue&type=style&index=0&id=7455a60b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455a60b",
  null
  
)

export default component.exports